
import { Button, Divider, Grid, Typography } from "@mui/material";
import { ErrorMessage, Field, Form, Formik } from 'formik';
import { editActivity, saveActivity } from "../../../redux";
import { useAppDispatch } from "../../../redux/hooks";

import { IActivity } from "../../../models/activities";
import '../../../themes/styles.css';


interface Props {
    onCancel: () => void,
    activity: IActivity,
    editing: boolean
}

export const MyForm = ({ onCancel, activity, editing }: Props) => {
    const dispatch = useAppDispatch();

    const onSave = (activity: IActivity) => {
        editing ? dispatch(editActivity(activity) as any) : dispatch(saveActivity(activity) as any);
    }

    return (
        <Grid>
            <Typography id="modal-modal-title" variant="h6" component="h2">
                Add Activity
            </Typography>
            <br />
            <Divider />
            <br />

            <Formik
                initialValues={activity}
                onSubmit={(values) => {
                    onSave(values as any);
                    onCancel();
                }}
            // validationSchema={Yup.object({
            //     name: Yup.string()
            //         .max(15, 'Debe de tener 15 caracteres o menos')
            //         .required('Requerido'),
            // })}
            >

                {(formik) => (
                    <Form>
                        <Grid container justifyContent="center" rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                            <Grid item xs={6}>
                                <Typography component="label" htmlFor="name">Name</Typography>
                                <Field name="name" type="text" />
                                <ErrorMessage name="name" component="span" className="error-message" />
                                <br />
                            </Grid>
                        </Grid>
                        <br />
                        <Grid container justifyContent="center">
                            <Button variant="outlined" type="reset" sx={{ width: 100 }} onClick={onCancel}>Cancel</Button>
                            &nbsp;&nbsp;&nbsp;
                            <Button variant="contained" type="submit" sx={{ width: 100 }} >Save</Button>
                        </Grid>
                    </Form>
                )
                }
            </Formik>
        </Grid >
    )
}

